<div class="h-full w-full p-8">
  <div class="content relative">
    <button
      (click)="toggleLanguage()"
      [class]="
        'border-primary text-primary hover-border-primary hover-bg-primary absolute top-6 flex h-9 cursor-pointer items-center justify-center gap-2 rounded-lg border-2 bg-white px-4 py-2 transition-all hover:text-white active:scale-95' +
        (currentLocale() === 'en' ? ' left-6' : currentLocale() === 'ar' ? ' right-6' : '')
      ">
      <svg class="h-4 w-4 transition-colors" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path d="M2 12H22" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path
          d="M12 2C14.5013 4.73835 15.9228 8.29203 16 12C15.9228 15.708 14.5013 19.2616 12 22C9.49872 19.2616 8.07725 15.708 8 12C8.07725 8.29203 9.49872 4.73835 12 2Z"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
      <span class="font-['Inter'] text-sm font-medium whitespace-nowrap transition-colors">
        {{ currentLocale() == "en" ? "العربية" : "English" }}
      </span>
    </button>

    <h1 class="text-[96px] font-bold" i18n="@@welcomeMessage">Welcome</h1>

    <p class="w-3/4 text-[32px]" i18n="@@descriptionMessage">
      PIMS is a platform designed for pharmaceutical distributors to streamline inventory management, track stock levels
      and expiry dates, and optimize warehouse operations.
    </p>

    <div class="mt-4 flex items-center gap-4">
      <a
        routerLink="/login"
        class="landing-btn border-primary text-primary hover-bg-primary-10 border-[2px]"
        i18n="@@login">
        Login
      </a>
      <a routerLink="/register" class="landing-btn bg-primary hover-bg-primary-hover text-white" i18n="@@register">
        Register
      </a>
    </div>
  </div>
</div>
